exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/node_modules/exports-loader?module.exports.toString()!C:/Temp/Avemov/Avemov-Angular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Temp/Avemov/Avemov-Angular/node_modules/postcss-loader?{"ident":"postcss"}!C:/Temp/Avemov/Avemov-Angular/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMenu/components/ubiMenuItem/ubiMenuItem.scss
// module id = ../../../../exports-loader/index.js?module.exports.toString()!../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/app/theme/components/ubiMenu/components/ubiMenuItem/ubiMenuItem.scss
// module chunks = main